const IMAGES = Object.freeze({
  DEFAULT: 'default',
  TICKETS: 'tickets',
});

export {IMAGES};
